/* @flow */
import * as React from 'react';
import styled from 'styled-components';

import { Box, Footer, Space, Text } from '@sonyged/proc-ui';
import { ProcModal } from '@sonyged/ext-proc';
import css from '@styled-system/css';

import type { Customer } from '../../../../sushi/rules/types';
import { CustomerComments } from './StatsModal/CustomerComments';
import { CustomerIcon } from '../../../../sushi/components/CustomerIcon';
import { EatenSushi } from './StatsModal/EatenSushi';
import { HeatMap } from './StatsModal/HeatMap';
import { Tab } from '../../../../common/components/Tab/Tab';
import { Tabs } from '../../../../common/components/Tab/Tabs';

type Props = {
  customer: ?Customer,
  onClose: Function,
};

export function SushiAdvanceCustomerStatModal(props: Props) {
  const { customer, onClose } = props;

  let modalContent = customer ? (
    <div key="modal" className={'proc-modal proc-modal--hint'}>
      <div className="proc-modal-container">
        <Space mb={[8, 8, 6]}>
          <TitleContainer>
            <AvatarContainer>
              <UserAvatar customer={customer} />
              <Text color="white" fontSize={[13, 13, 16]} lineHeight="title">
                {customer.age}才
              </Text>
            </AvatarContainer>
            <Title>年れいが近い人の記録</Title>
          </TitleContainer>
        </Space>

        <div className={'proc-modal-contents'} style={{ marginTop: 0, marginBottom: 0 }}>
          <Contents>
            <ModalTabs>
              <Tab title="比率">
                <HeatMap customer={customer} />
              </Tab>
              <Tab title="感想">
                <CustomerComments customer={customer} />
              </Tab>
              <Tab title="種類">
                <EatenSushi customer={customer} />
              </Tab>
            </ModalTabs>
          </Contents>
        </div>
      </div>
      <Footer shadow={false}>
        <Footer.MainButton onClick={onClose} className="modal-close-se">
          とじる
        </Footer.MainButton>
      </Footer>
    </div>
  ) : (
    <span />
  );

  return (
    <ProcModal isOpened={Boolean(customer)} rootNodeId="proc-sushi-fields-root-page">
      {modalContent}
    </ProcModal>
  );
}

const ModalTabs = styled(Tabs)(
  css({
    flex: 1,
    minHeight: 0,
    '.proc-tabbar': {
      mb: [8, 8, 18], // "real" margin are 20/30 because there is also padding of 12 for gradient
    },
  })
);

const Contents = styled(Box)(
  css({
    position: 'relative',
    flex: 1,
    minHeight: 0,
    display: 'flex',
    flexDirection: 'column',
    px: 16,
    // maskImage: 'linear-gradient(to top, transparent 0%, black 12px, black calc(100% - 12px),  transparent 100%)',
  })
);

const UserAvatar = styled(CustomerIcon)(
  css({
    size: [35, 35, 48],
    bg: '#fff',
    borderRadius: '50%',
    mr: [6, 6, 8],
  })
);

const TitleContainer = styled.div(
  css({
    display: 'flex',
    justifyContent: 'center',
    mx: [16, 0, 0],
    fontSize: ['mobile.large', 'smallPC.large', 36],
    color: 'white',
    lineHeight: 'title',
  })
);

const AvatarContainer = styled.div({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
});

const Title = styled.span(
  css({
    display: 'inline-flex',
    alignItems: 'center',
    height: [35, 35, 48],
  })
);
